import { getVisualBuilderMode } from "@/utils/visualBuilder";

export const visualBuilderDataSelector = (params) => (state) => {
  const { key } = getVisualBuilderMode(params);

  return {
    visualBuilderData: state.visualBuilderData[key] || {},
  };
};
